import { useState, useEffect } from "react";
import { InputLabel, ErrorMessage } from "app/components/atoms/form";
import { Select } from "app/components/atoms/select";

function SelectMolecule({
  testId,
  label,
  name,
  placeholder,
  options = [],
  value,
  onChange = () => {},
  errorMessage,
  hideLabel = false,
  absolute = true,
  disabled = false,
}) {
  const [localValue, setLocalValue] = useState(value);
  const localOnChange = (event) => {
    setLocalValue(event.target.value);
    onChange(event);
  };

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  return (
    <div className="h-full">
      {!hideLabel && <InputLabel>{label}</InputLabel>}
      <Select
        testId={testId ?? (name ? `${name}-select` : undefined)}
        placeholder={placeholder}
        name={name}
        options={options}
        onChange={localOnChange}
        value={localValue}
        absolute={absolute}
        disabled={disabled}
      />
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </div>
  );
}

export default SelectMolecule;
